import styled from '@emotion/styled';

export const BlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
  align-items: stretch;
  flex-grow: 1;
`;

export const BlockHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  font-weight: bold;
  font-size: 18px;
`;

export const BlockContent = styled.div`
  background-color: ${({ color }) => color};
  padding: 16px;
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
  overflow: hidden;
  flex-grow: 1;
  flex-flow: row wrap;
  align-content: flex-start;

  &.full-height {
    overflow: auto !important;
    height: auto !important;
  }

  .one-line & {
    height: 180px;
    flex-grow: 0;
  }
`;
